import { render } from "./Verifications.vue?vue&type=template&id=208f5f8b"
import script from "./Verifications.vue?vue&type=script&lang=js"
export * from "./Verifications.vue?vue&type=script&lang=js"

import "./Verifications.vue?vue&type=style&index=0&id=208f5f8b&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__